import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.SettingsPopupContent', {
    title: 'Budget Checking settings',
    saveButton: 'Save',
    amountSectionTitle: 'During budget check, ApprovalMax should check:',
    learnMore: 'Learn more',
    itemGrossAmount: 'Gross amount',
    itemNetAmount: 'Net amount',
    setBudgetSettingsSuccessMessage: 'Budget settings updated',
});
